
import React from "react";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Tt with dynamic content
 * @param JSX.Element children: Text or JSX element (required)
 * @param String classes: Add extra classNames for <th> (optional)
 * @param String key: Identifier key for <tr> (optional)
 * @returns {JSX.Element}
 */
const CustomTr = ({children, classes}) =>
{

    return <tr className={classes}>{children}</tr>

}
export default CustomTr;
